<template>
  <img
    v-if="result.imagePath"
    :src="imagePath"
    :alt="result.title"
    :title="result.title"
    :width="imageWidth"
    :height="imageHeight"
    class="img-fluid"
    loading="lazy"
  />
</template>

<script>
import { mapGetters } from '../store';

export default {
  name: 'SearchResultImage',

  props: {
    /** @type {import('vue').PropOptions<import('../store/state').SearchResult>} */
    result: {
      type: Object,
      required: true,
    },

    /** @type {import('vue').PropOptions<{ imageWidth: number, imageHeight: number }>} */
    dimensions: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['cdnDomain']),

    /** @returns {string} */
    imagePath() {
      return this.cdnDomain
        ? `${this.cdnDomain}${this.result.imagePath}?maxsidesize=400`
        : `${this.result.imagePath}?maxsidesize=400`;
    },

    /** @returns {number} */
    imageWidth() {
      return this.dimensions.imageWidth || 100;
    },

    /** @returns {number} */
    imageHeight() {
      return this.dimensions.imageHeight || 100;
    },
  },
};
</script>
